// extracted by mini-css-extract-plugin
export var article_card = "ArticleCard-module--article_card--SUwwR";
export var article_thumbnail_wrapper = "ArticleCard-module--article_thumbnail_wrapper--5itP7";
export var recent = "ArticleCard-module--recent--wbkWv";
export var article_thumbnail = "ArticleCard-module--article_thumbnail--XJGs4";
export var article_details = "ArticleCard-module--article_details--2X0r9";
export var article_title = "ArticleCard-module--article_title--K+shI";
export var article_tags = "ArticleCard-module--article_tags--KBQSz";
export var article_tag = "ArticleCard-module--article_tag--OnMHn";
export var article_date = "ArticleCard-module--article_date--eTS9l";
export var article_excerpt = "ArticleCard-module--article_excerpt--wf+3G";